__turbopack_context__.v({
  "backHomeBtn": "index-module-scss-module__pLKY9a__backHomeBtn",
  "desc": "index-module-scss-module__pLKY9a__desc",
  "errorContainer": "index-module-scss-module__pLKY9a__errorContainer",
  "title": "index-module-scss-module__pLKY9a__title",
});
